export const DEEPLINKURL = {
  'MX': `https://go.onelink.me/BRB5/db37b55?poiCountryCode=MX`,
  'JP': `https://didi.onelink.me/JQRD/451a929c?poiCountryCode=JP`,
  'BR': `https://go.onelink.me/WOyH?pid=Eater%20get%20Eater&poiCountryCode=BR`,
  'CR': `https://go.onelink.me/BRB5/db37b55?poiCountryCode=CR`,
  'CO': `https://go.onelink.me/BRB5/db37b55?poiCountryCode=CO`,
  'DO': `https://go.onelink.me/BRB5/db37b55?poiCountryCode=DO`,
  'CL': `https://go.onelink.me/BRB5/db37b55?poiCountryCode=CL`
}
